import { getFetchPaths } from 'tinymce-data/api/DataTokens';
import { getPathsMap, buildPaths } from 'rich-text-lib/utils/buildProperties';
let propertiesPromise = null;
export const initDataTokens = (editor, dataTokenSettingsConfig) => {
  const {
    apiClient
  } = editor.settings;
  const pathsMap = getPathsMap(dataTokenSettingsConfig);
  if (pathsMap) {
    propertiesPromise = Promise.resolve();
  } else {
    const fetchPaths = getFetchPaths(apiClient, dataTokenSettingsConfig);
    return fetchPaths().then(paths => {
      buildPaths(dataTokenSettingsConfig, paths);
      return paths;
    });
  }
  return propertiesPromise;
};